import axios from "axios";

export default {
  namespaced: true,
  state: {
    payrollrecurrings: [],
    query: null,
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    currentEmployeeId: null,
  },
  mutations: {
    SET_QUERY(state, payload) {
      console.log(payload);
      state.query = payload;
    },
    UPDATED_CURRENT_EMPLOYEEID(state, id) {
      state.currentEmployeeId = id;
    },
    RECEIVED_PAYROLL_RECURRINGS(state, payload) {
      state.payrollrecurrings = payload;
      state.isReceiving = false;
    },
    RECEIVING_ACCOUNTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_PAYROLL_RECURRING(state, payload) {
      state = Object.assign(state, {
        payrollrecurrings: [...state.payrollrecurrings, payload],
        isReceiving: false,
        currentEmployeeId: payload.employeeid,
      })
    },
    RECEIVING_ACCOUNT(state) {
      state.isReceiving = true;
    },
    UPDATED_ACCOUNT(state, payload) {
      state.currentEmployeeId = payload._id;
      let index = state.payrollrecurrings.findIndex(payrollrecurring => payrollrecurring._id === payload._id);
      state = Object.assign(state, {
        payrollrecurrings: state.payrollrecurrings.map((payrollrecurring, i) => {
          if (i === index) {
            return Object.assign({}, payrollrecurring, payload);
          }
          return payrollrecurring;
        }),
        isUpdating: false,
        payrollrecurringsMessage: 'PayrollRecurrings has been updating!',
      })
    },
    UPDATING_ACCOUNT(state) {
      state.isUpdating = true;
    },
    DELETED_ACCOUNT(state, payload) {
      let indexToDelete = state.payrollrecurrings.findIndex(payrollrecurring => payrollrecurring._id === payload._id);
      console.log(indexToDelete);
      let payrollrecurrings = [...state.payrollrecurrings];
      payrollrecurrings.splice(indexToDelete, 1);
      state = Object.assign(state, {
        payrollrecurrings: [...payrollrecurrings],
        isDeleting: false,
        idToDelete: null,
        payrollrecurringsMessage: 'PayrollRecurring has been Deleted!',
      });
    },
    DELETING_ACCOUNT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    setCurrentEmployeeId({dispatch}, id){
      dispatch("updatedCurrentEmployeeId",id);
    },
    async getPayrollRecurringsRequest({dispatch, state}) {
      if(state.query!=null) {
        console.log("have query")
        dispatch("getPayrollRecurringsByQueryRequest", state.query);
        return;
      }
      dispatch("receivingPayrollRecurrings");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/payrollrecurrings';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers}).then(response => {
        dispatch("receivePayrollRecurrings", response.data);
      })
    },
    async getPayrollRecurringsByQueryRequest({dispatch}, payload) {
      dispatch("receivingPayrollRecurrings");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/payrollrecurrings/byquery';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "POST", url: url, headers: headers, data: payload}).then(response => {
        console.log(response.data)
        dispatch("receivePayrollRecurrings", response.data);
      })
    },
    async updatePayrollRecurring({dispatch}, payload) {
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/payrollrecurring/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updatedPayrollRecurring", res.data);
        dispatch("updatedCurrentEmployeeId", res.data.employeeid);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async insertPayrollRecurring({dispatch}, payload) {
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/payrollrecurring';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: payload})
      .then((response) => {
        dispatch("receivedPayrollRecurring", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deletePayrollRecurringRequest({dispatch}, payload) {
      dispatch("deletingPayrollRecurring", payload);
      axios.delete('https://api.tradexc.com:3000/delete/payrollrecurring/' + payload._id).then(() => {
        dispatch("deletedPayrollRecurring", {_id: payload._id});
      })
    },
    setQuery({commit}, payload) {
      commit("SET_QUERY", payload)
    },
    updatedCurrentEmployeeId({commit}, id) {
      commit("UPDATED_CURRENT_EMPLOYEEID", id)
    },
    receivePayrollRecurrings({commit}, payload) {
      commit("RECEIVED_PAYROLL_RECURRINGS", payload)
    },
    receivingPayrollRecurrings({commit}) {
      commit("RECEIVING_ACCOUNTS")
    },
    receivedPayrollRecurring({commit}, payload) {
      commit("RECEIVED_PAYROLL_RECURRING", payload)
    },
    receivingPayrollRecurring({commit}) {
      commit("RECEIVING_ACCOUNT")
    },
    updatedPayrollRecurring({commit}, payload) {
      commit("UPDATED_ACCOUNT", payload)
    },
    updatingPayrollRecurring({commit}) {
      commit("UPDATING_ACCOUNT")
    },
    deletedPayrollRecurring({commit}, payload) {
      commit("DELETED_ACCOUNT", payload)
    },
    deletingPayrollRecurring({commit}, payload) {
      commit("DELETING_ACCOUNT", payload)
    }
  },
};
